import instance from "../axios/axios";

// Fetch all patients with pagination and search
export const downloadReport = async (type,startDate,EndDate) => {
    try {
        const response = await instance.get(`/api/reports/${type}?startDate=${startDate}&EndDate=${EndDate}`, {
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${type}-report.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error(error);
        throw error; 
    }
}